module.exports = __webpack_public_path__ + "static/img/VDproduct2.506837a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/VDproduct2.png
// module id = ruGX
// module chunks = 0